module.exports = __webpack_public_path__ + "static/media/skitchin2.dcf8e545.gif";